const TEXT = "text";
const TEXTAREA = "textarea";
const EMAIL = "email";
const PASSWORD = "password";

const TYPES = {
  TEXT,
  TEXTAREA,
  EMAIL,
  PASSWORD
};

export default TYPES;
